if(typeof BSS_B2B && window.location.pathname === '/pages/dealer-registration-form') {
    $(".form-vertical").addClass("account-page-content");
    $(".field, .rendered-form .form-group:not(.formbuilder-autocomplete, .formbuilder-file)").each((ind, item) => {
        $(item).addClass("form-field");
        const input = $(item).find("input");
        const label = $(item).find("label");
        if(input) {
            input.addClass("form-field-input");
            if(label) {
                label.addClass("form-field-title");
                input.after(label);
            }
        }
    })
  $('.formbuilder-autocomplete.form-group.field-country-field').addClass("form-field")
const countryChildren = $('.formbuilder-autocomplete.form-group.field-country-field').children()
    countryChildren[0].classList.add("form-field-title")
    countryChildren[1].placeholder = ' ';
countryChildren[1].classList.add("form-field-input")
    countryChildren[2].placeholder = ' '
    countryChildren[2].setAttribute('type','text')
    countryChildren[2].style.display = "none";
    countryChildren[3].after(countryChildren[0])

let autocompleteList = document.querySelector(".formbuilder-autocomplete ul");
    let autocompleteLabel = document.querySelector(".formbuilder-autocomplete label");
    let autocompleteInput = document.querySelector(".formbuilder-autocomplete input");

    autocompleteList.addEventListener("click", () => {
      autocompleteLabel.classList.add("handle-transition");
    });

    autocompleteInput.addEventListener("focus", event => {
      autocompleteLabel.classList.add("handle-transition");
    });

    autocompleteInput.addEventListener("blur", event => {
      if (event.target.value) {
        autocompleteLabel.classList.add("handle-transition");
      } else {
        autocompleteLabel.classList.remove("handle-transition");
      }
    });
}